import * as types from '../type'
import { setStore, getStore, clearStore, merge, getCookie } from 'service/utils'
import VueCookies from "vue-cookies"

const state = {
    user: {},
    constantCache : null,
    roleCache : null,
}

const getters = {
    user: state => {
        if(state.user.access_token){
            return state.user
        }
        return getStore('user') || {}
    },
    token: state => {
        if(state.user.access_token){
            return state.user.access_token
        }
        return getStore('user') && getStore('user').access_token || ''
    },
    constantCacheVersion: state => {
        if(state.constantCache){
            return state.constantCache.version
        }
        return getStore('constantCache') && getStore('constantCache').version || ''
    },
    constantCacheData: state => {
        if(state.constantCache){
            return state.constantCache.data
        }
        return getStore('constantCache') && getStore('constantCache').data || {}
    },
    roleCacheVersion : state => {
        if(state.roleCache){
            return state.roleCache.version
        }
        return getStore('roleCache') && getStore('roleCache').version || ''
    },
    roleCacheData : state => {
        if(state.roleCache){
            return state.roleCache.data
        }
        return getStore('roleCache') && getStore('roleCache').data || {}
    }
}

const actions = {
    set_user({commit,dispatch}, data){
        commit(types.SETUSER, data)
        dispatch(`global/set_roleMessageCount`, data.unread_message || 0, {root: true}) 
    },
    set_cookie({commit,dispatch}, data){
        commit(types.SETCOOKIE, data)
    },

    exit({commit}){
        commit(types.EXIT)
    },

    set_constantCache({commit}, data){
        commit(types.SETCONSTANTCACHE, data)
    },

    set_roleCache({commit}, data){
        commit(types.SETROLECACHE, data)
    },
}
const mutations = {
    [types.SETUSER](state, data){
        setStore('user', data)
        state.user = merge({}, data)
    },
    [types.SETCOOKIE](state, data){
        /* key, value, expireTimes, path, domain, secure, sameSite */
        if(self != top){
            VueCookies.set('token',data.access_token,(data.expires_in-3600)+'s','/','','','None')
        }else{
            VueCookies.set('token',data.access_token,(data.expires_in-3600)+'s')
        }
    },

    [types.EXIT](state){
        state.user = ''
        clearStore()
        VueCookies.remove('token')
        if(self != top){
            VueCookies.set('token','','','/','','','None')
        }
    },

    [types.SETCONSTANTCACHE](state, data){
        setStore('constantCache', data)
        state.constantCache = merge({}, data)
    },

    [types.SETROLECACHE](state, data){
        setStore('roleCache', data)
        state.roleCache = merge({}, data)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js